import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export function renderRelevanceStatusIcon(
  icon: LucideIcon,
  colorClass: string,
  options?: { iconClassName?: string; ariaLabel?: string },
) {
  const Icon = icon;
  return (
    <span
      className={cn("inline-flex shrink-0 items-center justify-center rounded-full p-1", colorClass)}
      aria-label={options?.ariaLabel}
    >
      <Icon className={cn("h-3 w-3", options?.iconClassName)} aria-hidden="true" />
    </span>
  );
}
